import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';

@Injectable()
export class NotificationService {

  constructor(private http: HttpClient, private headers: HttpHeadersService) { }
  // all notifiaction data
  getAllNotification(request: any) {
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.getAllNotification;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  // selected notification data
  getAllNotificationData(request: any) {
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.getAllNotificationData;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  // global toggle
  toggleAllNotifications(request: any) {
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.toggleNotifications;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  // update notifications
  updateNotification(request: any){
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.updateNotification;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  getNotificationPartnerList(){
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.getNotificationPartnerList;
    return this.http.get(url, this.headers.getCommonHttpHeaders());

  }

  sendCustomDateNotification(request){
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.sendCustomDateNotification;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }

  searchTransactionsArchive(request: any) {
    var url: string = Urls.NOTIFICATION_ENDPOINT + Urls.NOTIFICATION.searchTransactionsArchive;
    return this.http.post<any>(url, request, this.headers.getCommonHttpHeaders());
  }
}